import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

@Component({
  selector: 'app-share-audit',
  templateUrl: './share-audit.component.html',
  styleUrls: ['./share-audit.component.css'],
})
export class ShareAuditComponent {
  constructor(public dialogRef: MatDialogRef<ShareAuditComponent>) {}

  email: string = '';

  get isValid(): boolean {
    return EMAIL_PATTERN.test(this.email.trim());
  }

  share(): void {
    if (!this.isValid) {
      return;
    }

    this.dialogRef.close(this.email.trim());
  }
}
